import * as React from 'react';

function SvgNoValidation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M22.67.26a1 1 0 01.15 1.31l-.08.1-20 22a1 1 0 01-1.56-1.24l.08-.1 20-22a1 1 0 011.41-.07zM21 5.81V23l-1.5-1.5-2 1.5-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5-2 1.5-.08-.05 2.71-2.98L9.5 21l2-1.5 2 1.5 2-1.5 2 1.5 2-1.5V7.46L21 5.81zM18.62 1l-1.36 1.5H5.5a1 1 0 00-1 1v13.03L3 18.18V3c0-1.1.9-2 2-2h13.62zm-5.97 14h4.85v1h-5.76l.91-1zm1.82-2h3.03v1h-3.94l.9-1zm-4.94-2l-.9 1H6.5v-1h3.03zm6.76 0h1.21v1h-2.12l.9-1zm-4.94-2l-.91 1H6.5V9h4.85zm1.82-2l-.91 1H6.5V7h6.67zm1.81-2l-.9 1H6.5V5h8.48z" />
    </svg>
  );
}

export default SvgNoValidation;
